import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const DraggableWrapper = styled.div<{ isDragging: boolean }>`
    position: relative;

    ${({ isDragging }) =>
        isDragging &&
        css`
            &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: ${colorsPalettes.carbon[25]};
                z-index: 1000;
            }
        `};
`;

export const DragOverlay = styled.div<{ isDragging: boolean }>`
    position: relative;

    background: ${colorsPalettes.carbon[0]};
    touch-action: none;
    cursor: grab;

    ${({ isDragging }) =>
        isDragging &&
        css`
            cursor: grabbing;
            z-index: 1;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        `}
`;

export const DraggableIcon = styled(SWReactIcons)<{ isDragging?: boolean }>`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);

    opacity: ${({ isDragging }) => (isDragging ? 1 : 0)};
    pointer-events: none;
    transition: opacity 200ms ease;

    ${DraggableWrapper}:hover & {
        opacity: 1;
    }

    &.SWReactIcons svg path:last-child {
        fill: ${colorsPalettes.carbon[200]};
    }
`;
